import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductGradeHeroComponent } from './product-grade-hero.component';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        ProductGradeHeroComponent,
    ],
    declarations: [
        ProductGradeHeroComponent,
    ],
    providers: []
})
export class ProductGradeHeroModule {
}
